module.exports = __webpack_public_path__ + "img/46032f0.png";